module.exports = {
  title: '',
  sitTitle: '',
  titleSeparator: ' - ',
  titleReverse: false,
  abbreviation: 'yddh-supertube-admin',
  copyright: '852235477@qq.com',
  keepAliveMaxNum: 20,
  isHashRouterMode: true,
  routesWhiteList: [
    '/login',
    '/register',
    '/forgetPwd',
    '/404',
    '/403',
    'systemSet',
    '/enterprise'
  ],
  loadingText: '正在加载中...',
  tokenName: 'token',
  tokenTableName: 'yddh-admin-token',
  tokenChannelName: 'yddh-channel-token',
  // token存储位置localStorage sessionStorage cookie
  storage: 'sessionStorage',
  recordRoute: false,
  logo: 'vuejs-fill',
  i18n: 'zh',
  messageDuration: 2000,
  errorLog: 'development',
  loginInterception: true,
  loginRSA: false,
  // intelligence(前端导出路由)和all(后端导出路由)两种方式
  authentication: 'all',
  supportVisit: false,
  rolesControl: false,
  uniqueOpened: false,
  defaultOpeneds: [],
  // 需要加loading层的请求，防止重复提交
  debounce: ['doEdit', 'config', 'survey'],
  openFirstMenu: true,
}
